import script from "./Page9.vue?vue&type=script&setup=true&lang=js"
export * from "./Page9.vue?vue&type=script&setup=true&lang=js"

import "./Page9.vue?vue&type=style&index=0&id=165ee653&lang=less"

const __exports__ = script;

export default __exports__